<template>
  <el-form label-width="100px" :inline="true" :model="form" class="demo-form-inline">
    <el-form-item label="优惠券名称" required>
      <el-input v-model="form.name" clearable />
    </el-form-item>
    <el-form-item label="类型" prop="type" required>
      <el-select v-model="form.type" placeholder="类型" clearable>
        <el-option v-for="item in typeOptions" :label="item.label" :key="item.label" :value="item.value" />
      </el-select>
    </el-form-item>
    <el-form-item label="数额" required>
      <el-input v-model="form.amount">
        <template v-if="form.type == 2" #append> % </template>
      </el-input>
    </el-form-item>
    <el-form-item label="状态" prop="status">
      <el-select v-model="form.status" placeholder="状态" clearable>
        <el-option v-for="item in openStatus" :label="item.label" :key="item.label" :value="item.value" />
      </el-select>
    </el-form-item>
    <el-form-item label="描述">
      <el-input v-model="form.description" clearable />
    </el-form-item>
  </el-form>
</template>

<script setup>
  import { nextTick, ref, onMounted, getCurrentInstance } from 'vue'
  import couponEnumHook from '@/hooks/couponEnumHook'

  const { openStatus, typeOptions } = couponEnumHook()

  const form = ref({
    name: '',
    amount: '',
    type: 1,
    status: 0,
    description: '',
    id: null,
  })
  const props = defineProps(['item'])

  onMounted(() => {
    nextTick(() => {
      form.value = Object.assign(form.value, props.item)
    })
  })

  const { proxy } = getCurrentInstance()

  defineExpose({ form })
</script>

<style lang="less" scoped>
  .demo-form-inline {
    justify-content: flex-start;
    display: flex;
    flex-wrap: wrap;
  }

  .demo-form-inline .el-input {
    --el-input-width: 220px;
  }

  .demo-form-inline .el-select {
    --el-select-width: 220px;
  }

  /deep/ .el-radio-group {
    width: 220px;
  }

  .form-title {
    text-align: left;
    padding-left: 30px;
    margin: 20px auto 10px;
    height: 44px;
    background-color: #f2f2f2;
    border-radius: 5px;
    line-height: 44px;
  }

  /deep/ .el-form-item {
    align-items: flex-start;
  }
</style>
